import SystemFailure from './SystemFailure';

export default SystemFailure;
